function findClosestPublicOU (id) {
  return {
    operationName: 'findClosestPublicOU',
    variables: {
      id
    },
    query: `
      query findClosestPublicOU($id:ID!) {
        closestPublicOrganisationalUnit(id: $id) {
          id
          titleDe
        }
      }
    `
  }
}

function fetchOrganisationalUnits ({ pageSize, page, sortField, sortOrder, filter }) {
  let variables = {
    pageSize: Number(pageSize) || 100,
    page: Number(page) || 1
  }

  if (sortOrder) {
    variables['sortOrder'] = sortOrder
  }

  if (sortField) {
    variables['sortField'] = sortField
  }

  if (filter && filter.text && filter.text.length > 0) {
    variables['filterText'] = filter.text
  }

  return {
    operationName: 'fetchOrganisationalUnits',
    variables,
    query: `
      query fetchOrganisationalUnits ($pageSize:Int!, $page:Int!, $sortOrder:SortOrder, $sortField:OrganisationalUnitSortKeys, $filterText:String!) {
        organisationalUnits(pageSize:$pageSize, page: $page, sortOrder:$sortOrder, orderBy:$sortField, filter: { text: $filterText }) {
          entries {
            ... on OrganisationalUnit {
              id
              name: titleDe
              title:_stringRep
              begin
              end
            }
          }
        }
      }
    `
  }
}

export { findClosestPublicOU, fetchOrganisationalUnits }



// WEBPACK FOOTER //
// ./src/graphql/organisationalUnits.js